<template>
  <div class="container">
    <div class="left">
      <div class="video-container">
        <resize-observer @notify="handleResize" />
        <bg-video-player
          :video="data.video"
          :getRef="setVideoRef"
          :currentTime="currentTime"
          :timeUpdate="timeUpdate"
          :newScrubberTime="newScrubberTime"
          :updateMetaData="handleVideoLoad"
        />
        <heatmapjs-vue
          class="heatmapjs-container"
          :max="100"
          :min="0"
          :data="heatData"
        ></heatmapjs-vue>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
.heatmapjs-container {
  width: 1000px;
  height: 500px;
  z-index: 100000;
}
</style>

<script>
import moment from "moment";
import BgVideoPlayer from "./bg-video-player";
export default {
  name: "bg-heatmap",
  components: {
    BgVideoPlayer,
  },
  props: {
    data: Object,
  },
  methods: {
    setVideoRef(ref) {
      this.videoRef = ref;
    },
    timeUpdate(time) {
      this.currentTime = time;
    },
    setNewTime(newTimePercentage) {
      this.newScrubberTime = this.videoRef.duration * newTimePercentage;
    },
    handleVideoLoad(video) {
      if (this.$route.query.timestamp) {
        const startTime = moment(this.data.started_at);
        const endTime = moment(this.data.ended_at);
        const startPos = moment(Number(this.$route.query.timestamp));
        const videoLength = endTime.diff(startTime, "seconds");
        const timeElapsed = startPos.diff(startTime, "seconds");
        this.setNewTime(timeElapsed / videoLength);
      }
      //this.totalTime = video.duration;
    },
    handleNueroPop(point) {
      if (this.nueroBubbles.find((nb) => (nb.id = point.id))) {
        return null;
      } else {
        this.nueroBubbles.push(point);
      }
    },
    handleResize() {
      this.eyeTrackerKey += 1;
    },
  },
  mounted() {
    // setInterval(() => {
    //   this.xValue = Math.random(10) * 1000;
    //   this.yValue = Math.random(25) * 1000;
    //   this.intensity = Math.random(100) * 100;
    //   const newData = { x: this.xValue, y: this.yValue, value: this.intensity };
    //   this.heatData.push(newData);
    //   setTimeout(() => {
    //     this.heatData[this.heatData.length - 5].value =
    //       this.heatData[this.heatData.length - 5].value - 35;
    //     this.heatData[this.heatData.length - 4].value =
    //       this.heatData[this.heatData.length - 4].value - 35;
    //     this.heatData[this.heatData.length - 3].value =
    //       this.heatData[this.heatData.length - 3].value - 35;
    //     this.heatData[this.heatData.length - 2].value = this.heatData[
    //       this.heatData.length - 2
    //     ].value;
    //     this.heatData[this.heatData.length - 1].value =
    //       this.heatData[this.heatData.length - 1].value - 35;
    //   }, 100);
    // }, 100);
  },
  data() {
    return {
      videoRef: null,
      totalTime: 0,
      currentTime: 0,
      newScrubberTime: 0,
      nueroBubbles: [],
      eyeTrackerKey: 1,
      xValue: 10,
      yValue: 15,
      intensity: 40,
      heatData: [{ x: 10, y: 10, value: 40 }],
    };
  },
};
</script>
